module.exports = __webpack_public_path__ + "static/BeaconDA-Regular-4f9a44fb98d2a33ab830727006537731.otf";